import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { UPLOAD_FILE_TYPE } from 'utils/constants/config'
import { getCountAllComplianceList } from 'services/apiKYE'
import { OPERATION_MESSAGES } from 'utils/constants/operations'
import FileManagerConfig from 'components/OptionsConfig/FileManagerConfig'

const ComplianceListConfig = () => {
  const token = useSelector((state) => state.auth.access_token)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const loadData = async () => {
      setLoading(true)

      try {
        setData(await getCountAllComplianceList(token, {}))
      } catch (error) {
        reportError(error)
        toast.error(OPERATION_MESSAGES.LOAD_DATA_FAIL)
      } finally {
        setLoading(false)
      }
    }

    loadData()
  }, [])

  return (
    <div>
      <FileManagerConfig
        fileType={UPLOAD_FILE_TYPE.deny_list_file}
        baseItemsCount={data?.total_items}
        loadingBase={loading}
      />
    </div>
  )
}

export default ComplianceListConfig
